import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { FavoriteIcon } from 'components/favorite-icon';
import { useAuthContext } from 'state/auth';

import { StoreCardActionsContainer } from './store-card-actions.styled';
import { StoreCardButton } from './store-card-button';

interface StoreCardActionsProps {
  onDiagnosticsClick?: () => void;
  onFavoritesClick?: () => void;
  onInfoPress?: () => void;
  isUpdatingFavorites?: boolean;
  isFavorite?: boolean;
  canBeSelected: boolean;
  containerStyle?: any;
}

export const StoreCardActions: React.FC<StoreCardActionsProps> = ({
  onDiagnosticsClick,
  onFavoritesClick,
  onInfoPress,
  isUpdatingFavorites,
  isFavorite,
  canBeSelected,
  containerStyle,
}) => {
  const { formatMessage } = useIntl();
  const { isAuthenticated } = useAuthContext();

  return (
    <StoreCardActionsContainer {...containerStyle}>
      {onDiagnosticsClick && (
        <StoreCardButton
          testID="store-favorite-button"
          accessibilityLabel="Open a diagnostic modal for this store"
          onPress={onDiagnosticsClick}
          icon={<Icon variant="settings" />}
        />
      )}
      {onInfoPress && canBeSelected && (
        <StoreCardButton
          accessibilityLabel={formatMessage({ id: 'info' })}
          onPress={onInfoPress}
          icon={<Icon size="$5" variant="info" aria-hidden />}
        />
      )}
      {isAuthenticated && onFavoritesClick && (
        <StoreCardButton
          accessibilityLabel={
            isFavorite
              ? formatMessage({ id: 'removeFavorite' })
              : formatMessage({ id: 'setRestaurantAsFavorite' })
          }
          onPress={onFavoritesClick}
          icon={<FavoriteIcon loading={isUpdatingFavorites} isFavorite={isFavorite} />}
          isDisabled={isUpdatingFavorites}
        />
      )}
    </StoreCardActionsContainer>
  );
};
